// @ts-nocheck
import React, { ReactNode, VFC } from 'react';
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MuiLink from '@material-ui/core/Link';

interface Props {
  href: string;
  children: ReactNode;
}
// TODO 型が分からなすぎるので、ts-nocheckにしている
const ProfileMenuListItem: VFC<Props> = ({
  href,
  children,
  ...others
}: { href?: string } & ListItemProps) => {
  return (
    <ListItem
      button
      {...others}
      {...(!!href && { href, component: MuiLink, underline: 'none' })}
    >
      <ListItemText secondary={children} />
    </ListItem>
  );
};

export default ProfileMenuListItem;
